import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Barba from "./barba";
import { EVENT } from "./constant";
import { Emitter } from "./core";
import Loading from "./core/Loading";
import SmoothScroll from "./core/SmoothScroll";
import Experience from "./experience/Experience";
import Exp from "./experience/Exp";

export default class App {
    constructor() {
        console.log(`We're hiring! https://www.facebook.com/bearplus.studio/photos/a.548152919005702/1357490188071967/`);
        window.SCROLL = new SmoothScroll().instance;
        window.onload = () => {
            window.SCROLL.stop();
            setTimeout(() => {
                window.SCROLL.scrollTo(0, { immediate: true })
            }, 10);

            this.pageName = document.querySelector('[data-barba-namespace]').getAttribute('data-barba-namespace');
            window.LOADING = new Loading(false, this.pageName);
            this.experience = new Exp(document.querySelector('canvas.experience'), this.pageName);
        }

        Emitter.on('loading_done', () => {
            this.init();
        })
    }

    core() {
        gsap.registerPlugin(ScrollTrigger);
        new Barba();
    }

    init() {
        this.core();
        console.log('Init app success')
    }
}
